import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/assess/task/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/assess/task/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/assess/task/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/assess/task/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/assess/task/update', params,options);

export const getProjectDic = (params, options) =>
request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

export const getStandardNameList = (params, options) =>
request.get('/api/v4ward/assess/standard/getNameList', Object.assign({}, options, { params }));

export const getStandardInfo = (params, options) =>
request.get('/api/v4ward/assess/standard/getStandardInfo', Object.assign({}, options, { params }));

export const getStandardDetailList_ = (params, options) =>
request.get('/api/v4ward/assess/task/standard/detail/getTaskStandardDetailList', Object.assign({}, options, { params }));

export const getStandardDetailList = (params, options) =>
request.get('/api/v4ward/assess/standard/detail/getStandardDetailList', Object.assign({}, options, { params }));

export const getAllUserByTaskId = (params, options) =>
request.get('/api/v4ward/assess/task/list/getAllUserByTaskId', Object.assign({}, options, { params }));

export const getAnalyseTaskStandardDetail = (params, options) =>
request.get('/api/v4ward/assess/task/standard/detail/getAnalyseTaskStandardDetail', Object.assign({}, options, { params }));

export const getFillScoreByTaskIdAndStandardDetailId = (params, options) =>
request.get('/api/v4ward/assess/task/list/getFillScoreByTaskIdAndStandardDetailId', Object.assign({}, options, { params }));

export const getAssessTaskListList = (params, options) =>
request.get('/api/v4ward/assess/task/list/getAssessTaskListList', Object.assign({}, options, { params }));

export const getSOLOTaskStandardDetail = (params, options) =>
request.get('/api/v4ward/assess/task/standard/detail/getSOLOTaskStandardDetail', Object.assign({}, options, { params }));

export const getAllDeptNameByTaskId = (params, options) =>
request.get('/api/v4ward/assess/task/list/getAllDeptNameByTaskId', Object.assign({}, options, { params }));

export const updateWorkStatus = (params, options) =>
request.post('/api/v4ward/assess/task/updateWorkStatus', qs.stringify(params),options);









